import React, {useRef} from 'react';

/**
 *
 */
export default function MachineCheckBox({data, generateCheckRef}) {
  const checkRef = useRef();
  return (
    <input
      type="checkbox"
      ref={generateCheckRef(data, checkRef)}
      className="form-check-input machine-assignment-checks"
      data-id={data}
    />
  );
}
